import { WorkNotes } from "@/features/Patient/MedicalRecords/WorkNotes";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/patient/$patientId/work-notes")({
  component: RouteComponent,
});

function RouteComponent() {
  return <WorkNotes />;
}
